<template>
  <div>
    <app-cells>
      <h1 class="title">Flying doctors insurance</h1>
    </app-cells>
    <app-tabs :tabs="tabs_to_show" />
    <transition name="fade" mode="out-in">
      <router-view />
    </transition>
  </div>
</template>

<script>
import AppTabs from '@/components/AppTabs'

export default {
  name: 'FlyingDoctorsListLayout',
  components: { AppTabs },
  data() {
    return {
      tabs: [ { name: 'safari-doctors-list-upcoming', label: 'Upcoming', roles: ['safari_flying_doctors', 'safari_supervisor', 'safari_manager', 'safari_assistant'] } ],
      tabs_to_show: [],
    }
  },
  created() {
    const tabs = []
    this.tabs.forEach(item => {
      if (!item.roles.length) {
        tabs.push(item)
        return
      }
      item.roles.forEach(role => {
        if (this.$store.state.userGroups.some(groupRole => groupRole.code === role)) tabs.push(item)
      })
    })
    this.tabs_to_show = tabs
  },
}
</script>
